import React from 'react';
import { Container, Row } from 'react-bootstrap';
import bookCorner from '../../images/bookCorner.png';
import championsLeague from '../../images/championsLeague.png';
import fb from '../../images/fb-1.png';
import interiorDesign from '../../images/interiorDesign.png';
import rapidShuttle from '../../images/rapidShuttle.png';
import sportsWiki from '../../images/sportsWiki.png';
import ProjectDetails from "../ProjectDetails/ProjectDetails";
const Projects = () => {
    const dataImg = [
        {
          img1:`${interiorDesign}`,
          img2:"https://i.ibb.co/G0xdb0Y/INTERIO-DESIGN-4.png",
          img3:"https://i.ibb.co/1Q55nNM/interior-Design-1.png",
          cols: 1,
          title: 'Interior Design Website',
          live:'https://interior-design-website.web.app/',
          code:'https://github.com/iMsubha/interio-design-client',
          text:`This full-stack website includes
          firebase authentication (email, google),
          react-router, react-bootstrap for
          responsive. In Server-side, mongodb,
          express js used and custom API
          created through firebase, deployed
          in heroku.`
        },
        {
          img1:`${bookCorner}`,
          img2:'https://i.ibb.co/Vw87509/bc-2.png',
          img3:"https://i.ibb.co/VNp4J4J/bc-1.png",
          cols: 2,
          title: 'Book Corner Website',
          live:'https://book-corner-app.firebaseapp.com/',
          code:'https://github.com/iMsubha/book-corner-client',
          text:`This full-stack website includes firebase
          authentication (email, google), reactrouter
          redirect. In Server-side, mongodb,
          express js used and custom api created
          through firebase, deployed in heroku.`,
        },
        {
            img1:`${sportsWiki}`,
            img2:"https://i.ibb.co/102CYFb/Sports-Wiki2.png",
            img3:"https://i.ibb.co/ZcTNt1D/Sports-Wiki3.png",
            cols: 1,
            title: 'Sports Wiki',
            live:'https://hungry-bohr-2412b4.netlify.app/',
            code:'https://github.com/iMsubha/sports-wiki',
            text:`This website includes firebase authentication (Facebook, email, google),react-router,
            react router redirect on click,also added google map`
          },
         
        {
          img1:`${championsLeague}`,
          img2:"https://i.ibb.co/tLx5h7D/Champions-League2.png",
          img3:"https://i.ibb.co/S3yJnPj/Champions-League1.png",
          cols: 1,
          title: 'Champions League',
          live:'https://quizzical-bell-b3754c.netlify.app/',
          code:'https://github.com/iMsubha/champions-league',
          text:`This react.js app shows the ability create JSON data and fetch using Hooks(useState, useEffect)`
        },
        {
            img1:`${rapidShuttle}`,
            img2:"https://i.ibb.co/VJY3JRq/Rapid-Shuttle2.png",
            img3:"https://i.ibb.co/6tys5Wb/Rapid-Shuttle.png",
            cols: 1,
            title: 'Rapid Shuttle',
            live:'https://react-auth-b8204.web.app/',
            code:'https://github.com/iMsubha/rapid-shuttle',
            text:`This react.js app shows the ability create JSON data and fetch using Hooks(useState, useEffect)`
          },
          {
            img1:`${fb}`,
            img2:"https://i.ibb.co/kMW4RKn/React-App.png",
            img3:"https://i.ibb.co/TWZhYrS/fb2.png",
            cols: 1,
            title: 'Facebook Clone',
            live:'https://facebook-clone-b6f0c.web.app/',
            code:'https://github.com/iMsubha/facebook-clone',
            text:`Developed React.js App which shows the ability to work with firebase for authentication, also, used react hooks, context API, Material UI`
          },
      ];
    
    return (
        <Container  className="pt-5">
             <Row>
                 {
                    dataImg.map(data =><ProjectDetails  data={data}></ProjectDetails>)
                 }
             </Row>
        </Container>
    );
};

export default Projects;